import { Axios } from "../../Config";
import { FormikValues } from "formik";

export const ChangePasswordService = (data: FormikValues) => {
  return Axios.put("/users/reset-password", data);
};
